import url from '../url'
import headers from '../headers'

export default {
	getLocation (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing/position`,
			headers.bearer()
		)
	},
	getAll (context, user_uid, watch_id, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing/${id}`,
			headers.bearer()
		)
	},
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing/${model.id}`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/geofecing/${id}`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/geofencing.js